import React, { useState } from "react";
import MilkCrateViewer from "./MilkCrateViewer";
import "./App.css";

function App() {
  const [tintColor, setTintColor] = useState("#ffffff"); // Start with clear glass
  const [selectedColor, setSelectedColor] = useState("#ffffff"); // Temporary color storage

  const applyColorChange = () => {
    setTintColor(selectedColor);
  };

  return (
    <div>
      <MilkCrateViewer tintColor={tintColor} />
      {/* Add UI elements to change color */}

      {/* Choose tint color: */}
      <div className="button-change">
        <label>
          Choose tint color:
          <input
            type="color"
            value={selectedColor}
            onChange={(e) => setSelectedColor(e.target.value)}
          />
        </label>
        <button onClick={applyColorChange}>Apply Color</button>
      </div>
    </div>
  );
}

export default App;
